// extracted by mini-css-extract-plugin
export default {"FundWallet":"FundWallet_FundWallet__Oq4oS","Wrapper":"FundWallet_Wrapper__Zw1BX"};